/**
 * Canonical asset condition rating scale (1–6) and its display labels.
 *
 * Single source of truth shared across the assets feature and PDF reports so the
 * integer condition_rating maps to identical text everywhere. Lives in shared
 * `constants/` (not a feature) so `lib/` report code can consume it without
 * violating the one-way dependency flow (features → shared, never shared → feature).
 *
 * RecordTestModal.jsx and AddAssetModal.jsx (via lib/assetCreation.js) both consume
 * this export directly — no local copies remain.
 */
export const CONDITION_RATINGS = [
  { value: 1, label: '1 — New' },
  { value: 2, label: '2 — Very Good' },
  { value: 3, label: '3 — Good' },
  { value: 4, label: '4 — Fair' },
  { value: 5, label: '5 — End of Life' },
  { value: 6, label: '6 — Removed / Disconnected' },
];

const CONDITION_LABEL_BY_VALUE = new Map(CONDITION_RATINGS.map((c) => [c.value, c.label]));

/**
 * Map a stored condition_rating (integer 1–6) to its display label.
 * Unrated assets (null/undefined/unknown value) render as an em dash — never a
 * fabricated default — so reports don't imply a rating that was never recorded.
 */
export function formatCondition(rating) {
  const numeric = Number(rating);
  if (!Number.isInteger(numeric)) return '—';
  return CONDITION_LABEL_BY_VALUE.get(numeric) ?? '—';
}
